'use client';

import { FC } from 'react';

import { BlogSectionType } from '../../../models/Content';
import { StyledSectionYoutubeEmbed } from './SectionYoutubeEmbed.styles';
import { transformSectionYoutubeEmbed } from './transformers';

type Props = {
    contentItem: BlogSectionType;
};

export const SectionYoutubeEmbed: FC<Props> = ({ contentItem }) => {
    const { youtubeEmbedUrl } = transformSectionYoutubeEmbed(contentItem);

    return (
        <StyledSectionYoutubeEmbed>
            <iframe
                src={youtubeEmbedUrl}
                height="100%"
                width="100%"
                title={youtubeEmbedUrl}
                frameBorder={0}
                allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen={true}
            />
        </StyledSectionYoutubeEmbed>
    );
};
